import { useIntl } from '@weenat/wintl';
export const useDecitraitCreateSanitaryStateNoteButton = (p) => {
    const { t } = useIntl();
    const nav = p.useNavigate();
    return {
        onPress: () => nav(`/farms/${p.orgId}/plots/${p.plot.id}/decitrait/sanitary-state-notes/create`),
        children: t('dss.decitrait.actions.create_sanitary_state_note')
    };
};
